// extracted by mini-css-extract-plugin
module.exports = {"productFlag":"campaign-flag_productFlag__xyGKw","campaignFlagImage":"campaign-flag_campaignFlagImage__jms8w"};